'use client';

import { submitPost } from '@/services/supabase-service';
import { Post } from '@/types/type';
import { media_host } from '@/utils/const';
import { supabase } from '@/utils/supabase';
import { Picker } from '@react-native-picker/picker';
import { Image } from 'expo-image';
import * as ImagePicker from 'expo-image-picker';
import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { Button, SafeAreaView, Text, TextInput, View } from 'react-native';

export default function CreatePost() {
  //const { user } = useUserStore();
  //const { selectedPlace } = usePlaceStore();
  //const { selectedBusker } = useBuskerStore();
  const { busker_id: busker_id, place_id: place_id } = useLocalSearchParams<{
    busker_id: string;
    place_id: string;
  }>();
  const buskerId = Array.isArray(busker_id) ? busker_id[0] : busker_id;
  const placeId = Array.isArray(place_id) ? place_id[0] : place_id;
  const [postData, setPostData] = useState<Post>({
    description: '',
    when: new Date().toISOString(),
  });
  const [isLoading, setIsLoading] = useState(false);
  const [descriptionText, onDescriptionChange] = useState('');
  const [dateText, onDateChange] = useState(postData.when);
  const [categoryText, onCategoryChange] = useState('');
  const [images, setImages] = useState<ImagePicker.ImagePickerAsset[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('image');

  useEffect(() => {
    setPostData({
      ...postData,
      description: descriptionText,
      when: dateText || new Date().toISOString(),
      category: categoryText,
      place_id: placeId,
      busker_id: buskerId,
    });
  }, [descriptionText, dateText, categoryText]);

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      for (const image of images) {
        const user_id = (await supabase.auth.getSession()).data.session?.user?.id;
        const arraybuffer = await fetch(image.uri).then((res) => res.arrayBuffer());
        const path = `${user_id}/${Date.now()}-${image.fileName}`;
        console.log('Uploading image to:', path);
        const { data, error: uploadError } = await supabase.storage
          .from('media')
          .upload(path, arraybuffer, {
            contentType: image.mimeType ?? 'image/jpeg',
          });
        if (uploadError) {
          throw uploadError;
        }
        console.log('Uploaded image:', data);
        postData.media_urls = [
          ...(postData.media_urls || []),
          { url: media_host + path, source: 'cdn', type: selectedCategory },
        ];
      }

      if (
        postData.media_urls &&
        postData.media_urls[0] &&
        postData.media_urls[0].type === 'image'
      ) {
        postData.image_url = postData.media_urls[0].url;
      }

      postData.category = selectedCategory;

      submitPost(postData);
    } catch (error) {
      console.error('Error creating post:', error);
    } finally {
      setIsLoading(false);
      router.back();
    }
  };

  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: [selectedCategory === 'video' ? 'videos' : 'images'],
      allowsMultipleSelection: true,
      allowsEditing: false,
    });

    console.log(result);
    if (!result.canceled) {
      setImages([...images, ...result.assets]);
    }
  };

  return (
    <SafeAreaView>
      <View className="max-w-2xl mx-auto p-4">
        <Text className="text-2xl font-bold mb-6">Create New Post</Text>

        <View>
          <Text className="block mb-2">Description</Text>
          <TextInput
            value={descriptionText}
            onChangeText={onDescriptionChange}
            className="w-full p-2 border rounded"
          />
        </View>

        <View>
          <Picker
            selectedValue={selectedCategory}
            onValueChange={(itemValue, itemIndex) => setSelectedCategory(itemValue)}>
            <Picker.Item label="Image" value="image" />
            <Picker.Item label="Video" value="video" />
            <Picker.Item label="Youtube" value="youtube" />
            <Picker.Item label="Event" value="event" />
          </Picker>
        </View>

        <View>
          <Text className="block mb-2">Date</Text>
          <TextInput
            value={dateText}
            onChangeText={onDateChange}
            className="w-full p-2 border rounded"
          />
        </View>

        {(selectedCategory === 'video' || selectedCategory === 'image') && (
          <Button title="Add files" onPress={pickImage}></Button>
        )}

        <Button disabled={isLoading} title="Create Post" onPress={handleSubmit}></Button>

        <View className="mt-4 w-full">
          {images.map((item, index) => (
            <View key={index}>
              <Text>
                {item.fileName} {index}
              </Text>
              <Image source={{ uri: item.uri }} className="w-full h-[250px]" contentFit="contain" />
            </View>
          ))}
        </View>
      </View>
    </SafeAreaView>
  );
}
